import { defineMessages } from 'react-intl';

/** The copy of "Redo the kit with the new cover" (design kit-redo-cover a, b, c). */
export const coverRedoMessages = defineMessages({
  // a · the banner
  oldTag: { id: 'app.sml.releases.kit.coverRedo.cover.old', defaultMessage: 'Old' },
  newTag: { id: 'app.sml.releases.kit.coverRedo.cover.new', defaultMessage: 'New' },
  bannerTitle: {
    id: 'app.sml.releases.kit.coverRedo.banner.title',
    defaultMessage:
      '{count, plural, one {Your cover changed. Redo # asset with the new cover.} other {Your cover changed. Redo # assets with the new cover.}}',
  },
  bannerBody: {
    id: 'app.sml.releases.kit.coverRedo.banner.body',
    defaultMessage:
      'So your posts, videos and SmartLink previews all match the new look. Layouts and texts stay as they are.',
  },
  notNow: { id: 'app.sml.releases.kit.coverRedo.banner.notNow', defaultMessage: 'Not now' },
  redo: {
    id: 'app.sml.releases.kit.coverRedo.banner.redo',
    defaultMessage: '{count, plural, one {Redo # asset} other {Redo # assets}}',
  },
  cost: {
    id: 'app.sml.releases.kit.coverRedo.banner.cost',
    defaultMessage: '{credits, plural, one {Uses # credit} other {Uses # credits}} · you have {left}',
  },
  costNoLimit: {
    id: 'app.sml.releases.kit.coverRedo.banner.costNoLimit',
    defaultMessage: '{credits, plural, one {Uses # credit} other {Uses # credits}}',
  },
  free: { id: 'app.sml.releases.kit.coverRedo.banner.free', defaultMessage: 'Free · images cost no credits' },
  watermark: {
    id: 'app.sml.releases.kit.coverRedo.banner.watermark',
    defaultMessage: 'On Free, the new files keep the MUSIC24 watermark.',
  },
  removeWatermark: {
    id: 'app.sml.releases.kit.coverRedo.banner.removeWatermark',
    defaultMessage: 'Remove it with a plan',
  },
  quietLine: {
    id: 'app.sml.releases.kit.coverRedo.quiet.line',
    defaultMessage:
      '{count, plural, one {# asset still uses your old cover. It keeps working until you redo it.} other {# assets still use your old cover. They keep working until you redo them.}}',
  },
  quietRedo: { id: 'app.sml.releases.kit.coverRedo.quiet.redo', defaultMessage: 'Redo with the new cover' },
  slotOldCover: { id: 'app.sml.releases.kit.coverRedo.slot.oldCover', defaultMessage: 'Old cover' },
  // The chips of the kinds (a1)
  kindImages: {
    id: 'app.sml.releases.kit.coverRedo.kind.images',
    defaultMessage: '{count, plural, one {# image} other {# images}}',
  },
  kindCoverSizes: {
    id: 'app.sml.releases.kit.coverRedo.kind.coverSizes',
    defaultMessage: '{count, plural, one {# cover size} other {# cover sizes}}',
  },
  kindLinkPreview: { id: 'app.sml.releases.kit.coverRedo.kind.linkPreview', defaultMessage: 'Link preview' },
  kindShortVideos: {
    id: 'app.sml.releases.kit.coverRedo.kind.shortVideos',
    defaultMessage: '{count, plural, one {# short video} other {# short videos}}',
  },
  kindFullVideos: {
    id: 'app.sml.releases.kit.coverRedo.kind.fullVideos',
    defaultMessage: '{count, plural, one {# full video} other {# full videos}}',
  },
  kindMusicVideo: {
    id: 'app.sml.releases.kit.coverRedo.kind.musicVideo',
    defaultMessage: '{count, plural, one {# music video} other {# music videos}}',
  },
  kindAiReels: {
    id: 'app.sml.releases.kit.coverRedo.kind.aiReels',
    defaultMessage: '{count, plural, one {# AI reel} other {# AI reels}}',
  },
  // b · the dialog
  dialogTitle: { id: 'app.sml.releases.kit.coverRedo.dialog.title', defaultMessage: 'Redo with the new cover' },
  dialogLead: {
    id: 'app.sml.releases.kit.coverRedo.dialog.lead',
    defaultMessage:
      'We make each file again with your new cover. Layouts, texts and settings stay the same, and the new versions replace the old ones in your kit.',
  },
  whatWeMake: { id: 'app.sml.releases.kit.coverRedo.dialog.whatWeMake', defaultMessage: 'What we make again' },
  fileCount: {
    id: 'app.sml.releases.kit.coverRedo.dialog.fileCount',
    defaultMessage: '{count, plural, one {# file} other {# files}}',
  },
  groupImages: { id: 'app.sml.releases.kit.coverRedo.group.images', defaultMessage: 'Images' },
  groupImagesNote: { id: 'app.sml.releases.kit.coverRedo.group.imagesNote', defaultMessage: 'Stories and feed posts' },
  groupCoverSizes: { id: 'app.sml.releases.kit.coverRedo.group.coverSizes', defaultMessage: 'Cover sizes' },
  groupCoverSizesNote: {
    id: 'app.sml.releases.kit.coverRedo.group.coverSizesNote',
    defaultMessage: '3000, 1400 and 640 px',
  },
  groupLinkPreview: { id: 'app.sml.releases.kit.coverRedo.group.linkPreview', defaultMessage: 'Link preview' },
  groupLinkPreviewNote: {
    id: 'app.sml.releases.kit.coverRedo.group.linkPreviewNote',
    defaultMessage: 'Your SmartLink shares update too',
  },
  groupShortVideos: { id: 'app.sml.releases.kit.coverRedo.group.shortVideos', defaultMessage: 'Short videos' },
  groupFullVideos: { id: 'app.sml.releases.kit.coverRedo.group.fullVideos', defaultMessage: 'Full videos' },
  groupMusicVideo: { id: 'app.sml.releases.kit.coverRedo.group.musicVideo', defaultMessage: 'Music video' },
  groupAiReels: { id: 'app.sml.releases.kit.coverRedo.group.aiReels', defaultMessage: 'AI reels' },
  groupAiReelsNote: {
    id: 'app.sml.releases.kit.coverRedo.group.aiReelsNote',
    defaultMessage: 'Same clips and cuts, new end card',
  },
  groupFree: { id: 'app.sml.releases.kit.coverRedo.group.free', defaultMessage: 'Free' },
  credits: {
    id: 'app.sml.releases.kit.coverRedo.credits',
    defaultMessage: '{credits, plural, one {# credit} other {# credits}}',
  },
  // b2 · the files that are left out
  skipNeedsPlan: {
    id: 'app.sml.releases.kit.coverRedo.skip.needsPlan',
    defaultMessage: 'Full-song videos are on Pro.',
  },
  skipNeedsPlanAiFootage: {
    id: 'app.sml.releases.kit.coverRedo.skip.needsPlanAiFootage',
    defaultMessage: 'AI footage is on paid plans.',
  },
  skipSeePro: { id: 'app.sml.releases.kit.coverRedo.skip.seePro', defaultMessage: 'See Pro' },
  skipNeedsMaster: {
    id: 'app.sml.releases.kit.coverRedo.skip.needsMaster',
    defaultMessage: 'Upload the master first.',
  },
  skipOpenSong: { id: 'app.sml.releases.kit.coverRedo.skip.openSong', defaultMessage: 'Open the song' },
  skipMasterProcessing: {
    id: 'app.sml.releases.kit.coverRedo.skip.masterProcessing',
    defaultMessage: 'Your song is still being read. Try again in a few minutes.',
  },
  skipBusy: {
    id: 'app.sml.releases.kit.coverRedo.skip.busy',
    defaultMessage: '{name} is being made now, so it gets the new cover anyway.',
  },
  skipFailed: {
    id: 'app.sml.releases.kit.coverRedo.skip.failed',
    defaultMessage: '{name} cannot be made again. Make it new in the Studio.',
  },
  // The posts
  postsTitle: {
    id: 'app.sml.releases.kit.coverRedo.posts.title',
    defaultMessage:
      '{count, plural, one {# scheduled post uses the old files} other {# scheduled posts use the old files}}',
  },
  postsMore: { id: 'app.sml.releases.kit.coverRedo.posts.more', defaultMessage: 'and {count} more' },
  postsMove: { id: 'app.sml.releases.kit.coverRedo.posts.move', defaultMessage: 'Move them to the new files' },
  postsMoveNote: {
    id: 'app.sml.releases.kit.coverRedo.posts.moveNote',
    defaultMessage: 'Each post switches when its new file is ready. Captions and times stay.',
  },
  postsPublished: {
    id: 'app.sml.releases.kit.coverRedo.posts.published',
    defaultMessage:
      '{count, plural, =0 {Posts that went out stay as they are.} one {Posts that went out stay as they are. # post went out with the old cover.} other {Posts that went out stay as they are. # posts went out with the old cover.}}',
  },
  postStatusDraft: { id: 'app.sml.releases.kit.coverRedo.posts.draft', defaultMessage: 'draft' },
  postStatusScheduled: { id: 'app.sml.releases.kit.coverRedo.posts.scheduled', defaultMessage: 'scheduled' },
  postStatusNeedsYou: { id: 'app.sml.releases.kit.coverRedo.posts.needsYou', defaultMessage: 'needs you' },
  // The footer
  left: { id: 'app.sml.releases.kit.coverRedo.footer.left', defaultMessage: 'You have {left} left' },
  leftNoLimit: {
    id: 'app.sml.releases.kit.coverRedo.footer.leftNoLimit',
    defaultMessage: 'Failed files give their credits back',
  },
  short: {
    id: 'app.sml.releases.kit.coverRedo.footer.short',
    defaultMessage: 'You have {left} left. Get {more} more, or untick the videos to redo the rest for free.',
  },
  cancel: { id: 'app.sml.releases.kit.coverRedo.footer.cancel', defaultMessage: 'Cancel' },
  redoCost: {
    id: 'app.sml.releases.kit.coverRedo.footer.redoCost',
    defaultMessage:
      '{count, plural, one {Redo # asset} other {Redo # assets}} · {credits, plural, one {# credit} other {# credits}}',
  },
  buyCredits: { id: 'app.sml.releases.kit.coverRedo.footer.buyCredits', defaultMessage: 'Buy credits' },
  // b3 · the error lines
  errorCostChanged: {
    id: 'app.sml.releases.kit.coverRedo.error.costChanged',
    defaultMessage:
      '{credits, plural, one {The cost changed to # credit.} other {The cost changed to # credits.}} A file finished or failed while you looked. Check the list and confirm again.',
  },
  errorBusy: {
    id: 'app.sml.releases.kit.coverRedo.error.busy',
    defaultMessage: 'These files are being made right now. Wait until they are ready, then redo the rest.',
  },
  errorNoMaster: {
    id: 'app.sml.releases.kit.coverRedo.error.noMaster',
    defaultMessage: 'Upload the master of the song first.',
  },
  errorMasterProcessing: {
    id: 'app.sml.releases.kit.coverRedo.error.masterProcessing',
    defaultMessage: 'Your song is still being read. Try again in a few minutes.',
  },
  errorOther: { id: 'app.sml.releases.kit.coverRedo.error.other', defaultMessage: 'That did not work. Try again.' },
  // c · progress, done, error
  progressTitle: {
    id: 'app.sml.releases.kit.coverRedo.progress.title',
    defaultMessage: 'Redoing with the new cover · {ready} of {total} ready',
  },
  progressBody: {
    id: 'app.sml.releases.kit.coverRedo.progress.body',
    defaultMessage: 'Each file swaps in as soon as it is ready. You can leave this page.',
  },
  progressBodyPosts: {
    id: 'app.sml.releases.kit.coverRedo.progress.bodyPosts',
    defaultMessage:
      '{count, plural, one {Each file swaps in as soon as it is ready. Your scheduled post moves with it. You can leave this page.} other {Each file swaps in as soon as it is ready. Your # scheduled posts move with them. You can leave this page.}}',
  },
  progressEta: { id: 'app.sml.releases.kit.coverRedo.progress.eta', defaultMessage: 'About {minutes} min left' },
  doneTitle: { id: 'app.sml.releases.kit.coverRedo.done.title', defaultMessage: 'Your kit has the new cover.' },
  doneBody: {
    id: 'app.sml.releases.kit.coverRedo.done.body',
    defaultMessage: '{count, plural, one {# asset made again.} other {# assets made again.}}',
  },
  donePosts: {
    id: 'app.sml.releases.kit.coverRedo.done.posts',
    defaultMessage: '{count, plural, one {# post now uses the new files.} other {# posts now use the new files.}}',
  },
  downloadZip: { id: 'app.sml.releases.kit.coverRedo.done.zip', defaultMessage: 'Download kit zip' },
  close: { id: 'app.sml.releases.kit.coverRedo.close', defaultMessage: 'Close' },
  failedTitle: {
    id: 'app.sml.releases.kit.coverRedo.failed.title',
    defaultMessage: '{count, plural, one {# asset could not be made again.} other {# assets could not be made again.}}',
  },
  failedBody: {
    id: 'app.sml.releases.kit.coverRedo.failed.body',
    defaultMessage: '{ready} of {total} have the new cover.',
  },
  failedCreditsBack: {
    id: 'app.sml.releases.kit.coverRedo.failed.creditsBack',
    defaultMessage: '{credits, plural, one {Your # credit is back.} other {Your # credits are back.}}',
  },
  tryAgain: { id: 'app.sml.releases.kit.coverRedo.failed.tryAgain', defaultMessage: 'Try again' },
});
